import React from 'react';

export default function Logo() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 5L8 15C8 15 10 25 20 35C30 25 32 15 32 15L20 5Z" fill="#DC2626" stroke="#991B1B" strokeWidth="2"/>
      <path d="M20 5L14 20L20 25L26 20L20 5Z" fill="#EF4444"/>
      <circle cx="20" cy="15" r="2" fill="#FCA5A5"/>
    </svg>
  );
}